<template>
  <div class="layout">
    <!-- 顶部导航栏 -->
    <div class="nav">
      <div class="sidebaricon" @click="toggleSidebar"></div>
      <div class="logo"></div>
    </div>
    <swiper :swiperList="swiperList" v-if="showSwiper"></swiper>
    <!-- 主体内容 -->
    <div class="content">
      <router-view />
    </div>
    <Footer />
    <!-- 侧边栏 -->
    <Sidebar :active="isSidebarOpen" @close="toggleSidebar" />
    <!-- 遮罩层 -->
    <div v-if="isSidebarOpen" class="mask" @click.self="toggleSidebar"></div>
  </div>
</template>

<script>
import Footer from "./footer.vue";
import Sidebar from "./Sidebar.vue";
import swiper from "./swiper.vue";
import { getGame } from "@/api/home";
export default {
  name: "DefaultLayout",
  components: {
    Footer,
    Sidebar,
    swiper,
  },
  data() {
    return {
      activeTab: 0,
      isSidebarOpen: false,
      swiperList: [],
    };
  },
  computed: {
    showSwiper() {
      // 设置你想显示 Swiper 的路径，例如仅在首页显示
      const showPaths = ["/", "/game"];
      return showPaths.includes(this.$route.path);
    },
  },
  created() {
    getGame({ position: 3 }).then((res) => {
      console.log(res);
      this.swiperList = res.result.items;
    });
  },
  methods: {
    toggleSidebar() {
      this.isSidebarOpen = !this.isSidebarOpen;
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: 48px;
  box-sizing: border-box;
  .content {
    flex: 1;
    padding: 0px 10px 0 16px;
    box-sizing: border-box;
    overflow: hidden;
    overflow-y: auto;
  }

  .nav {
    width: 100%;
    height: 48px;
    background: #141414;
    padding: 12px 16px;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;

    .sidebaricon {
      background: url("@/assets/layout/sidebar.png") no-repeat;
      background-size: 100% 100%;
      width: 24px;
      height: 24px;
      cursor: pointer;
    }

    .logo {
      background: url("@/assets/layout/footlogo.png") no-repeat;
      background-size: 100% 100%;
      width: 85px;
      height: 30px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 9px;
    }
  }

  .mask {
    position: fixed;
    top: 48px;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 9998;
  }
}
</style>
